<ngx-loading 
  [show]="loading" 
  [config]="loaderConfig"
  [template]="customLoadingTemplate">
</ngx-loading>

<ng-template #customLoadingTemplate>
  <div style="color: white; font-size: 16px; text-align: center; margin-top: 20px;">
    Loading...
  </div>
</ng-template>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport 
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" 
    [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  
  <mat-sidenav-content>
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h3>{{ getDashboardTitle(currentUserRole) }}</h3> 
    </mat-toolbar>

    <div class="content-body">
      <router-outlet></router-outlet>

      <div *ngIf="!router.url.includes('/dashboard/') && isUnknownRole(currentUserRole)" class="default-dashboard">
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="dashboard-header text-center">
                  <mat-icon style="font-size: 48px; color: #630f12;">dashboard</mat-icon>
                  <h4>Welcome to AUCDT Management Portal</h4>
                  <p>Please wait while we load your personalized dashboard, or select a module from the navigation menu to get started.</p>
                  <div *ngIf="currentUser">
                    <p>Logged in as: <strong>{{userFullName}}</strong></p>
                    <p>Role: <strong>{{getRoleDisplayName(currentUserRole || '')}}</strong></p>
                    <button mat-raised-button color="warn" (click)="testLoginService()" style="margin-top: 20px;">
                      Debug Role Issue (Check Console)
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>


